import { render, staticRenderFns } from "./XSelect.vue?vue&type=template&id=7b23920d&scoped=true&"
import script from "./XSelect.vue?vue&type=script&lang=js&"
export * from "./XSelect.vue?vue&type=script&lang=js&"
import style0 from "./XSelect.vue?vue&type=style&index=0&id=7b23920d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b23920d",
  null
  
)

export default component.exports